import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import {
  OTPGenerate as otpGenerateAction,
  OTPGenerateAction, OTPGenerateClear as otpGenerateClearAction,
  OTPGenerateResponse,
} from '@triare/auth-redux/dist/saga/auth/OTP';
import { AnyObject } from '@triare/auth-redux';
import { connect } from 'react-redux';
import { timeResendOTPCode } from '../../../../contstant';
import { RootState } from '../../../../store';
import { moduleName } from '../../../../store/auth';

interface ResendButtonProps {
  OTPGenerate: (payload?: OTPGenerateAction) => void;
  OTPGenerateClear: () => void;
  otpGenerateLoading: boolean;
  otpGenerateResponse: OTPGenerateResponse | null;
  otpGenerateError: null | AnyObject;
}

function ResendButton({
  OTPGenerate,
  OTPGenerateClear,
  otpGenerateLoading,
  otpGenerateResponse,
  otpGenerateError,
}: ResendButtonProps) {
  const [resendClick, setResentClick] = useState(false);
  const [startTime, setStartTime] = useState(Date.now() - timeResendOTPCode);
  const [time, setTime] = useState(0);
  const calcTime = () => Math.round((startTime + timeResendOTPCode + 1 - Date.now()) / 1000);

  useEffect(() => {
    if (otpGenerateResponse && !otpGenerateError) {
      setStartTime(Date.now());
    }
  }, [otpGenerateResponse, otpGenerateError]);

  useEffect(() => {
    if (resendClick) {
      const id = setInterval(() => {
        const seconds = calcTime();

        if (seconds > 0) {
          setTime(seconds);
        } else {
          setTime(0);
          clearInterval(id);
          setResentClick(false);
        }
      }, 1000);

      return () => clearInterval(id);
    }

    return () => {};
  }, [resendClick]);

  return (
    <div style={{ textAlign: 'center' }}>
      <Button
        type="link"
        onClick={(e) => {
          e.preventDefault();

          const seconds = calcTime();

          if (seconds > 0) {
            setTime(seconds);
            setResentClick(true);
          } else {
            OTPGenerate({});
          }
        }}
        loading={otpGenerateLoading}
      >
        Resend link to email
      </Button>
      {resendClick ? (
        <div style={{ color: 'red', padding: '8px 0' }}>
          Wait
          {' '}
          {time}
          {' '}
          seconds and then you can get a new code.
        </div>
      ) : null}
    </div>
  );
}

export default connect(
  (state: RootState) => ({
    otpGenerateResponse: state[moduleName].OTP.generate.response,
    otpGenerateError: state[moduleName].OTP.generate.error,
    otpGenerateLoading: state[moduleName].OTP.generate.loading,
  }),
  {
    OTPGenerate: otpGenerateAction,
    OTPGenerateClear: otpGenerateClearAction,
  },
)(ResendButton);
